import type { Hydratable } from '@vimcar/mvvm/hydratable'

import * as dataMapper from '@vimcar/mvvm/dataMapper'
import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import type { ContentType } from '../'

type _KeyValuePair = {
  id: string
  title: string
  key: string
  value: string
  contentModelType: ContentType
}

// @ts-expect-error@2314
export type KeyValuePair = Hydratable<_KeyValuePair, object>

const mkKeyValuePair = hydratable(
  () => {
    const keyValuePair = mobx.observable({
      contentModelType: 'keyValuePair',
    } as _KeyValuePair)
    return keyValuePair
  },
  'KeyValuePair',
  {
    fields: dataMapper.lift({}),
    sys: dataMapper.lift({
      id: true,
    }),
  },
)

export default mkKeyValuePair
